import type { ReactNode } from 'react';
import { Description, Heading } from '@heroui/react';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex min-w-0 flex-col gap-1">
        <Heading level={1} className="text-2xl font-semibold">
          {title}
        </Heading>
        {description ? <Description>{description}</Description> : null}
      </div>
      {actions ? <div className="shrink-0 pt-1">{actions}</div> : null}
    </div>
  );
}
